import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'sb-account-number',
    templateUrl: './account-number.component.html',
    styleUrls: ['./account-number.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, NgClass, FormFieldLabelComponent, TranslateModule],
})
export class AccountNumberComponent implements OnInit {
    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}

    ngOnInit(): void {
        this.formField.value = this.formField.value?.slice(0, 11) || '';
    }

    onPaste(event: ClipboardEvent): void {
        const pastedData = event.clipboardData?.getData('text') || '';
        this.preventPastingNotNumberValue(pastedData, event);
    }

    onDrop(event: DragEvent): void {
        const pastedData = event.dataTransfer?.getData('text') || '';
        this.preventPastingNotNumberValue(pastedData, event);
    }

    onKeyDown(event: KeyboardEvent): void {
        if (!HelperService.isKeyAllowedForNumberField(event)) {
            this.preventPastingNotNumberValue(event.key, event);
        }
    }

    private preventPastingNotNumberValue(testedValue, event) {
        if (!/^[0-9]+$/.test(testedValue)) {
            event.preventDefault();
        }
    }
}
